import { useTranslation } from "react-i18next";
import { NotificationBell } from "../Inbox/NotificationBell";
import type { UiTheme } from "../theme";
import { Segment } from "./Segment";
import { BellSegmentIcon } from "./segmentIcons";

// The bell as the last segment of the experience switcher row (INBOX-10). One
// callsite for both mounts (the phone's ShellChrome and the web shell); the
// bell keeps all its logic, this only draws the trigger as a Segment.
export function ExperienceBellSegment({
  theme,
  bottomInset,
}: {
  theme: UiTheme;
  bottomInset?: number;
}) {
  const { t } = useTranslation();
  const label = t("inbox.bell.label", { defaultValue: "Alerts" });
  return (
    <NotificationBell
      theme={theme}
      bottomInset={bottomInset}
      renderTrigger={({ onPress, accessibilityLabel, withBadge }) => (
        <Segment
          role="button"
          icon={BellSegmentIcon}
          label={label}
          // WCAG 2.5.3: the spoken name starts with the visible word.
          accessibilityLabel={`${label}, ${accessibilityLabel}`}
          onPress={onPress}
          palette={theme.palette}
          renderIcon={withBadge}
        />
      )}
    />
  );
}
